import { postRequest, getRequest } from "common/HttpClient/http-utility";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";

const mapFormToCreateUserPayload = (formData) => {
  const role = formData.attributes?.role ?? "User";
  const customerCode = formData.attributes?.customerCode?.[0];
  const phoneNumber = formData.attributes?.mobile_number?.[0];
  const payload = {
    username: formData.username?.trim() ?? "",
    email: formData.email?.trim() ?? "",
    phoneNumber: phoneNumber ?? "",
    role,
    customerCode: customerCode,
    accessTo: Array.isArray(formData.accessTo) ? formData.accessTo : ["DASHBOARD"],
  };
  return payload;
};

const mapUserExistsResponse = (response) => {
  if (response?.error) return response;
  const body = response?.data;
  const existsFlag = body?.exists ?? body?.data?.exists;
  const isExists = existsFlag === true;
  return { status: response?.status, data: isExists ? true : null };
};

const mapCreateUserResponse = (data) => {
  if (!data) return data;
  return {
    id: data.id,
    username: data.username,
    email: data.email,
    phoneNumber: data.phoneNumber,
    role: data.role,
    customerCode: data.customerCode,
    accessTo: data.accessTo ?? [],
    isActive: data.isActive,
  };
};

export const CreateUserServices = () => {
  const apiPaths = INFRAMARK_CONSTANTS.users.services;
  const groupApiPaths = INFRAMARK_CONSTANTS.groups.services;
  const services = {
    createNewUser: async (userInfo) => {
      const payload = mapFormToCreateUserPayload(userInfo);
      const response = await postRequest(apiPaths.createUser, payload);
      if (response?.data) {
        response.data = mapCreateUserResponse(response.data);
      }
      return response;
    },
    checkUserExists: async (params = {}) => {
      const queryParams = {};
      const name = params.username;
      if (name != null && String(name).trim() !== "") {
        queryParams.username = String(name).trim();
      }
      if (params.email != null && String(params.email).trim() !== "") queryParams.email = String(params.email).trim();
      if (params.phoneNumber != null && String(params.phoneNumber).trim() !== "") queryParams.phoneNumber = String(params.phoneNumber).trim();
      const response = await getRequest(apiPaths.usersExists, queryParams);
      return mapUserExistsResponse(response);
    },
    validateUser: async (username) =>
      mapUserExistsResponse(
        await getRequest(
          apiPaths.usersExists,
          username != null && String(username).trim() !== ""
            ? { username: String(username).trim() }
            : undefined
        )
      ),
    validateEmail: async (emailId) => mapUserExistsResponse(await getRequest(apiPaths.usersExists, emailId != null && String(emailId).trim() !== "" ? { email: String(emailId).trim() } : undefined)),
    validateMobilenumber: async (mobileNumber) => mapUserExistsResponse(await getRequest(apiPaths.usersExists, mobileNumber != null && String(mobileNumber).trim() !== "" ? { phoneNumber: String(mobileNumber).trim() } : undefined)),
    getAllGroups: async () => {
      const response = await getRequest(`${groupApiPaths.activeGroups}`);
      return response;
    },
  };
  return services;
};
